import React from 'react';

interface StatusDotProps {
  status?: string | null;
}

const StatusDot: React.FC<StatusDotProps> = ({ status }) => {
  if (!status) {
    return <div className="w-2 h-2 rounded-full bg-[#94a3b8]" />;
  }

  const isStandard = status.toLowerCase() === 'standard';
  const isOptional = status.toLowerCase() === 'optional';

  return (
    <div
      className={`w-2 h-2 rounded-full ${
        isStandard
          ? 'bg-[#16a34a]'
          : isOptional
          ? 'bg-[#d97706]'
          : 'bg-[#94a3b8]'
      }`}
    />
  );
};

export default StatusDot;
